import { gql } from '@apollo/client';

export const ADD_BRAND_PRODUCT_CATEGORY = gql`
  mutation AddBrandProductCategory($input: AddBrandProductCategoryInput!) {
    addBrandProductCategory(input: $input) {
      id
      name
      usedByBrandsCount
    }
  }
`;

export const UPDATE_BRAND_PRODUCT_CATEGORY = gql`
  mutation UpdateBrandProductCategory(
    $input: UpdateBrandProductCategoryInput!
  ) {
    updateBrandProductCategory(input: $input) {
      id
      name
      usedByBrandsCount
    }
  }
`;

export const DELETE_BRAND_PRODUCT_CATEGORY = gql`
  mutation DeleteBrandProductCategory(
    $input: DeleteBrandProductCategoryInput!
  ) {
    deleteBrandProductCategory(input: $input) {
      id
      name
      usedByBrandsCount
    }
  }
`;
